import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@/lib/http';
import { storefrontApi } from '../api/client';
import { storefrontKeys } from '../api/keys';
import type { StorefrontHomeResponse } from '../api/types';

/**
 * A home curada, já no recorte de marcas do buyer.
 *
 * `staleTime` alto de propósito: a resposta é o snapshot de um recomputo que
 * roda em ciclos de minutos, e o servidor já mantém o próprio cache por escopo.
 * Refazer a chamada a cada volta para `/` custaria uma requisição por
 * clique para um dado que não muda entre elas.
 */
export function useStorefrontHome() {
  const query = useQuery<StorefrontHomeResponse, ApiError>({
    queryKey: storefrontKeys.home(),
    queryFn: () => storefrontApi.home(),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });

  const data = query.data ?? null;

  return {
    data,
    /** Nem destaque, nem ranking, nem marca — a home não tem o que mostrar. */
    isEmpty:
      data !== null &&
      data.featured.length === 0 &&
      data.bestsellers_female.length === 0 &&
      data.brands.length === 0,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => {
      void query.refetch();
    },
  };
}
